const registry = new Map();
export function registerArmyBundle(armies, source) {
    registry.set(source, armies);
}
export function getRegisteredArmies() {
    return [...registry.values()].flat();
}
export function clearArmyRegistry() {
    registry.clear();
}
